import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2023“开放的六月”最受大众喜爱作品奖投票';
const baseUrl = 'CMBYZ0524';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'showcreaten',
      name: `${baseUrl}-showcreaten`,
      component: () => import('./pages/Showcreaten.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'imgcreatewaynfds',
      name: `${baseUrl}-imgcreatewaynfds`,
      component: () => import('./pages/Imgcreateway.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
